module.exports = __webpack_public_path__ + "img/luv-logo-small.85e59b9f.png";